import ContentLoader from "react-content-loader";
import classes from "./style.module.scss";

export const SkeletonProvider = () => {
  return (
    <div className={classes.skeleton_field}>
      <ContentLoader
        speed={2}
        width={239}
        height={68}
        viewBox="0 0 239 68"
        backgroundColor="var(--chat-content-loader)"
        foregroundColor="var( --chat-content-loader-foreground)"
      >
        <circle cx="203" cy="34" r="25" />
        <rect x="80" y="15" rx="4" ry="4" width="85" height="18" />
        <rect x="7" y="43" rx="4" ry="4" width="156" height="9" />
      </ContentLoader>
      <ContentLoader
        speed={2}
        width={239}
        height={68}
        viewBox="0 0 239 68"
        backgroundColor="var(--chat-content-loader)"
        foregroundColor="var( --chat-content-loader-foreground)"
      >
        <circle cx="203" cy="34" r="25" />
        <rect x="80" y="15" rx="4" ry="4" width="85" height="18" />
        <rect x="7" y="43" rx="4" ry="4" width="156" height="9" />
      </ContentLoader>
      <ContentLoader
        speed={2}
        width={239}
        height={68}
        viewBox="0 0 239 68"
        backgroundColor="var(--chat-content-loader)"
        foregroundColor="var( --chat-content-loader-foreground)"
      >
        <circle cx="203" cy="34" r="25" />
        <rect x="80" y="15" rx="4" ry="4" width="85" height="18" />
        <rect x="7" y="43" rx="4" ry="4" width="156" height="9" />
      </ContentLoader>
      <ContentLoader
        speed={2}
        width={239}
        height={68}
        viewBox="0 0 239 68"
        backgroundColor="var(--chat-content-loader)"
        foregroundColor="var( --chat-content-loader-foreground)"
      >
        <circle cx="203" cy="34" r="25" />
        <rect x="80" y="15" rx="4" ry="4" width="85" height="18" />
        <rect x="7" y="43" rx="4" ry="4" width="156" height="9" />
      </ContentLoader>
    </div>
  );
};
